import React from 'react';

const ProgressBar = ({ progress }) => {
  return (
    <div className="w-full h-1 bg-secondary relative overflow-hidden">
      <div 
        className="h-full bg-primary transition-all duration-500 ease-out"
        style={{ width: `${progress}%` }}
      />
      <div 
        className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/30 to-transparent animate-pulse"
        style={{ 
          left: `${Math.max(0, progress - 20)}%`,
          width: '20%'
        }}
      />
    </div>
  );
};

export default ProgressBar;